module.exports = __webpack_public_path__ + "img/31.56c5f9d7.png";